import styled from "styled-components"
import { mobile, medScreen, mobilePortrait } from "../../Responsive"

export const Image = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 1;
    transition: opacity 0.3s ease;

    ${mobile({ height: "60vh" })}
    ${mobilePortrait({ height: "40vh" })}
`

export const Container = styled.div`
    flex: 1;
    height: 50vh;
    position: relative;
    overflow: hidden;

    &:hover ${Image} {
        opacity: 0.8;
    }
    
    ${mobile({ height: "60vh", width: "100vw" })}
    ${mobilePortrait({ height: "40vh", width: "100vw" })} 
`


export const Info = styled.div`
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 2;
`


export const Title = styled.h1`
    color: var(--white);
    margin-bottom: 20px;

    @media screen and (max-width: ${medScreen}) {
        font-size: var(--fontM);
    }
`